"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginLogger = void 0;
var lambda_log_1 = require("lambda-log");
var LoginLogger = /** @class */ (function () {
    function LoginLogger() {
        var _this = this;
        this.basicError = function (errorType) {
            _this.logger.info("login_error: ".concat(errorType), {
                reason: errorType,
            });
        };
        this.errorWithData = function (errorType, response) {
            _this.logger.info("login_error: ".concat(errorType), {
                reason: errorType,
                response: response,
            });
        };
        this.logger = new lambda_log_1.LambdaLog();
    }
    return LoginLogger;
}());
exports.LoginLogger = LoginLogger;
